import React, { PureComponent } from "react";

export default class TD extends PureComponent {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="13"
        viewBox="0 0 512 341.337"
      >
        <g transform="translate(0 -85.331)">
          <rect
            width="512"
            height="341.337"
            transform="translate(0 85.331)"
            fill="#ffda44"
          />
          <rect
            width="170.663"
            height="341.337"
            transform="translate(0 85.331)"
            fill="#0052b4"
          />
          <rect
            width="170.663"
            height="341.337"
            transform="translate(341.337 85.331)"
            fill="#d80027"
          />
        </g>
      </svg>
    );
  }
}
